var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3261 8.50617C15.5296 8.3318 15.6313 8.24461 15.6686 8.14086C15.7013 8.0498 15.7013 7.9502 15.6686 7.85914C15.6313 7.75539 15.5296 7.6682 15.3261 7.49383L8.26719 1.44331C7.917 1.14315 7.74191 0.993063 7.59367 0.989386C7.46483 0.986191 7.34177 1.04279 7.26035 1.14269C7.16667 1.25764 7.16667 1.48825 7.16667 1.94948V5.52886C5.38777 5.84007 3.75966 6.74146 2.54976 8.09489C1.23069 9.57043 0.501029 11.48 0.5 13.4591V13.9691C1.37445 12.9157 2.46626 12.0638 3.70063 11.4716C4.78891 10.9495 5.96535 10.6403 7.16667 10.5588V14.0505C7.16667 14.5117 7.16667 14.7424 7.26035 14.8573C7.34177 14.9572 7.46483 15.0138 7.59367 15.0106C7.74191 15.0069 7.917 14.8569 8.26719 14.5567L15.3261 8.50617Z",
    stroke: "#5B34FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.0e1198919a5277b491388c522da99880.svg";
export { ForwardRef as ReactComponent };